const getEnumValues = <T extends Object>(
  enumToDeconstruct: T
): Array<keyof typeof enumToDeconstruct> => {
  return Object.keys(enumToDeconstruct) as Array<keyof typeof enumToDeconstruct>;
};

export default getEnumValues;
